import React from "react"
import T from "prop-types"
import classNames from "classnames"
import { omit } from "lodash"

// import FontAwesomeWebPack from 'font-awesome-webpack';
import DialogLess from "./styles/symbols.less"
import styles from "./icon.less"

const getClass = (props) => {
  const types = ["icon", "fa"]

  var type = props.icon.split("-").shift()
  if (types.indexOf(type) === -1) {
    return ""
  }

  return classNames(
    type,
    { "icon-spin": props.spin, [styles.disabled]: props.disabled },
    props.icon,
    props.className,
  )
}

const Icon = (props) => {
  const transformedProps = {
    ...omit(props, ["icon", "dataQa", "spin", "className"]),
    onClick: props.disabled ? () => {} : props.onClick,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    onMouseDown: props.onMouseDown,
    onMouseUp: props.onMouseUp,
    className: getClass(props),
    disabled: props.disabled,
    tabIndex: props.tabIndex,
    autoFocus: props.autoFocus,
    style: props.style,
    title: props.title,
    ["data-qa"]: props.dataQa,
  }

  return <i {...transformedProps} />
}

Icon.propTypes = {
  className: T.any,
  icon: T.string.isRequired,
  spin: T.bool,
  onClick: T.func,
}

export default Icon
